import React, { Fragment, useEffect, useState } from 'react';
import api from '../../../../api';
import {
  Customer,
  DateFormats,
  formatDate,
  getLeadTitle,
  IUpdateEventModel,
  Lead,
} from '../../../../core';
import { ActivityPopup } from './edit-activity-popup';
import 'react-widgets/dist/css/react-widgets.css';
import '../../../../styles/details.scss';
import { LeadActivityListing } from './lead-activity-listing';
import RemoteDataDropDown from '../../../../components/dropdown/RemoteDataDropDown';
import { EditEventCalendarWraper } from '../../../../core/components/calendar/edit-event-calendar-wraper';
import { ActivityModel } from './add-activity';
import initialize from '../../../../core/store/initializeStore';
import SearchLead from '../../../lead-360-view/components/SearchLead';
import { LeadAutoFillItem } from '../../../../components/form-group/lead-activity-autocomplete-input';
import SearchCustomerDebounce from './SearchCustomerDebounce';

interface ICreateEventPopupProps {
  onSubmit: (event: IUpdateEventModel) => void;
  onClose: () => void;
  initialData?: ActivityModel;
  resourceType?: string;
  changeLead?: boolean;
  loadCurrentTime?: boolean;
}

export const CreateEventPopup: React.FunctionComponent<ICreateEventPopupProps> = (
  props
) => {
  const [selectedDate, setSelectedDate] = useState(
    props.initialData?.timePeriod?.startDate
  );
  const [showCalendar, setShowCalendar] = useState(false);
  const [leadId, setLeadId] = useState<Lead>();
  const [customer, setCustomer] = useState<Customer>();
  const [reloadTrigger, setReloadTrigger] = useState(false);
  const [currentActivity, setCurrentActivity] = useState(props.initialData);
  const [salesPersonId, setSalesPersonId] = useState(
    props.initialData?.salesPerson?._id
  );

  useEffect(() => {
    setLeadId(undefined);
  }, [customer]);

  const loadLeads = async () => {
    const response = await api.lead.getLeads({
      page: 1,
      perPage: 1000,
      customerId: customer?._id,
    });
    const leads: Lead[] = response?.data ?? [];
    leads.forEach((p) => {
      if (!p.title) {
        p.title = getLeadTitle(p);
      }
    });
    return leads;
  };
  const getCustomerDisplayName = (currentCustomer?: Customer) => {
    if (currentCustomer == null) {
      return '';
    }
    return (
      currentCustomer.fullName ||
      currentCustomer.name ||
      `${currentCustomer?.firstName || ''} ${currentCustomer?.lastName || ''}`
    );
  };

  return (
    <Fragment>
      <ActivityPopup
        header={'Create Event'}
        onClose={() => {
          props.onClose();
        }}
      >
        <div className="row mx-0 ch-100">
          <div className="col-12 py-4 border-right">
            <div className="position-relative">
              <SearchCustomerDebounce
                defaultValue={getCustomerDisplayName(customer)}
                labelText={'CUSTOMER'}
                wraperClassName={''}
                skipRedirection={true}
                onSelect={(currentCustomer: Customer) => {
                  setCustomer(currentCustomer);
                }}
              ></SearchCustomerDebounce>
            </div>
            {customer != null && (
              <div
                className="mt-3 form-group font-weight-semibold mb-0"
                key={'lead-dropdown-' + (customer?._id ?? '')}
              >
                <label className="font-sm">LEAD/DEAL</label>
                <RemoteDataDropDown
                  loadData={loadLeads}
                  textField={'title'}
                  onChange={(val: Lead) => {
                    setLeadId(val);
                    if (props.changeLead) {
                      if (val.currentSalesPerson && currentActivity) {
                        currentActivity.salesPerson = {
                          _id: val.currentSalesPerson?._id || '',
                          name: val?.currentSalesPerson?.name || '',
                        };
                      }
                      if (val.showroom && currentActivity) {
                        currentActivity.showRoom = {
                          _id: val.showroom?._id || '',
                          title: val.showroom.title || '',
                        };
                      }
                      setCurrentActivity({
                        ...currentActivity,
                      });
                    }
                  }}
                  placeholder="Select Lead"
                  itemComponent={(lead: any) => {
                    return (
                      <LeadAutoFillItem lead={lead.item}></LeadAutoFillItem>
                    );
                  }}
                ></RemoteDataDropDown>
              </div>
            )}
            <div
              className="mt-3"
              key={'lead-activity-listing-' + (customer ?? '') + (leadId ?? '')}
            >
              <LeadActivityListing
                customerId={customer?._id}
                onDatechange={setSelectedDate}
                onChangeAssignee={(value) => {
                  setSalesPersonId(value);
                }}
                onAfterCreate={() => {
                  setReloadTrigger(!reloadTrigger);
                }}
                onFormToggle={(show) => {
                  setShowCalendar(show);
                }}
                initialData={currentActivity}
                leadId={leadId?._id!}
                lead={leadId}
                resourceType={props.resourceType}
                loadCurrentTime={props.loadCurrentTime}
                isCustomerActivity
              ></LeadActivityListing>
            </div>
          </div>
          {/* <div className="col-sm-7 col-12">
            {showCalendar && (
              <EditEventCalendarWraper
                resourceId={salesPersonId}
                selectedDate={selectedDate!}
                onDateChange={(date: Date) => {
                  setSelectedDate(date);
                }}
                reloadTrigger={reloadTrigger}
                onSelectSlot={(start: Date, end: Date) => {
                  if (currentActivity) {
                    const clone = { ...currentActivity };
                    if (!clone.timePeriod) {
                      clone.timePeriod = {};
                    }
                    clone.timePeriod.startTime = formatDate(
                      start,
                      DateFormats.TimeOnlyFormat
                    );
                    clone.timePeriod.endTime = formatDate(
                      end,
                      DateFormats.TimeOnlyFormat
                    );
                    clone.timePeriod.startDate = start;
                    setCurrentActivity(clone);
                  }
                }}
              ></EditEventCalendarWraper>
            )}
          </div> */}
        </div>
      </ActivityPopup>
    </Fragment>
  );
};
